import { forwardRef, Ref } from 'react';
import { Checkbox as CheckboxPR, CheckboxChangeEvent, CheckboxProps } from 'primereact/checkbox';
import { CheckIcon } from './icons';

export const Checkbox = forwardRef((props: CheckboxProps, ref?: Ref<CheckboxPR>) => {
  return <CheckboxPR ref={ref} {...props} icon={props.icon || <CheckIcon />} />;
});

export type { CheckboxChangeEvent, CheckboxProps };
